// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as CatalogRoutes from "./CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantEditForm from "../../modules/Catalog/CatalogVariantEditForm.res.js";
import * as CatalogVariantEditPage from "./CatalogVariantEditPage.res.js";
import * as CatalogVariantEdit__Config from "./CatalogVariantEdit__Config.res.js";
import * as CatalogVariantEdit__Queries from "./CatalogVariantEdit__Queries.res.js";
import * as CatalogPlaceholderShopPicker from "../../modules/Catalog/CatalogPlaceholderShopPicker.res.js";

function CatalogVariantEditContainer(props) {
  let mode = props.mode;
  let cku = props.cku;
  let match = CatalogVariantEdit__Queries.ProductsQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let productsQueryResults = match[1];
  let executeProductsQuery = match[0];
  let match$1 = CatalogVariantEdit__Queries.VariantQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeVariantQuery = match$1[0];
  let match$2 = CatalogVariantEdit__Queries.ProductQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeProductQuery = match$2[0];
  let onGoBack = Navigation.useGoBack()[1];
  let navigate = Navigation.useNavigate();
  let notifier = Notifier.use("KeepOnHistoryChanges", undefined);
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let activeShopId = Stdlib_Option.map(activeShop, shop => shop.id);
  React.useEffect(() => {
    if (cku !== undefined && shops.length > 1) {
      executeProductsQuery(undefined, undefined, CatalogVariantEdit__Queries.ProductsQuery.makeVariables(CatalogVariantEdit__Queries.ProductsQuery.makeInputObjectInputProductsQueryFilter(undefined, undefined, undefined, undefined, CatalogVariantEdit__Queries.ProductsQuery.makeInputObjectInFilter([cku], undefined), undefined, "INCLUDED", undefined)));
    }
  }, []);
  let disabledShopIds = React.useMemo(() => {
    if (productsQueryResults.TAG !== "Executed") {
      return [];
    }
    let match = productsQueryResults._0.data;
    if (match === undefined) {
      return [];
    }
    let products = match.products.edges;
    return Stdlib_Array.filterMap(shops, param => {
      let id = param.id;
      let match = products.find(param => param.node.shop.id === id);
      if (match !== undefined) {
        return;
      } else {
        return id;
      }
    });
  }, [productsQueryResults]);
  let renderShopSelectionItem = React.useCallback(param => {
    let item = param.item;
    if (item.TAG !== "Option") {
      return null;
    }
    let value = item.value;
    let shopName = Stdlib_Option.mapOr(value, "", shop => shop.name);
    let match = Stdlib_Option.isSome(value);
    let match$1 = Stdlib_Option.getOr(item.disabled, false);
    if (match) {
      if (match$1) {
        return JsxRuntime.jsxs(Inline.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: shopName,
              variation: "placeholder"
            }),
            JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Non existing product"),
                variation: "subdued",
                size: "xsmall",
                lineHeight: "large"
              }),
              align: "end",
              grow: true
            })
          ],
          align: "spaceBetween",
          alignY: "top",
          grow: true
        });
      } else {
        return JsxRuntime.jsx(TextStyle.make, {
          children: shopName
        });
      }
    } else {
      return JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Select a shop"),
        variation: "normal"
      });
    }
  }, []);
  React.useEffect(() => {
    if (mode === "Create") {
      if (activeShop !== undefined && cku !== undefined) {
        executeProductQuery(undefined, undefined, CatalogVariantEdit__Queries.ProductQuery.makeVariables(Scalar.CKU.serialize(cku), CatalogVariantEdit__Config.makeProductFilterBy(activeShopId), undefined));
      }
    } else if (activeShop !== undefined && cku !== undefined) {
      executeVariantQuery(undefined, undefined, CatalogVariantEdit__Queries.VariantQuery.makeVariables(Scalar.CKU.serialize(cku), CatalogVariantEdit__Config.makeVariantFilterBy(activeShopId), undefined));
    }
  }, [activeShopId]);
  let onSubmitSuccess = React.useCallback(newVariantCku => {
    if (mode === "Create") {
      if (cku !== undefined) {
        return navigate({
          replace: true
        }, CatalogRoutes.productRoute(cku));
      } else {
        return navigate(undefined, CatalogRoutes.productRoute(Stdlib_Option.getOr(newVariantCku, "")));
      }
    }
    notifier.reset({
      TAG: "Success",
      _0: I18n.t("The variant information have been correctly updated.")
    }, undefined, undefined);
    onGoBack();
  }, []);
  let onSubmitFailure = React.useCallback(message => notifier.reset({
    TAG: "Error",
    _0: message
  }, undefined, undefined), []);
  let results = CatalogVariantEdit__Config.use(match$1[1], match$2[1]);
  let tmp;
  if (typeof results !== "object") {
    tmp = results === "Error" ? JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      }) : JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
  } else {
    let match$3 = results._0;
    tmp = JsxRuntime.jsx(CatalogVariantEditForm.Core.LegacyProvider.make, {
      initialValues: match$3.initialValues,
      schema: CatalogVariantEditForm.schema,
      children: JsxRuntime.jsx(CatalogVariantEditPage.make, {
        editionMode: mode === "Edit",
        formattedName: match$3.formattedName,
        shopName: match$3.shopName,
        productTaxRate: match$3.productTaxRate,
        productKind: match$3.productKind,
        productValues: match$3.productValues
      }),
      id: match$3.id,
      onSubmitFailure: onSubmitFailure,
      onSubmitSuccess: onSubmitSuccess
    });
  }
  return JsxRuntime.jsx(CatalogPlaceholderShopPicker.make, {
    children: tmp,
    message: I18n.template(I18n.t("Please select the shop in which you would like to {{action}} the reference."), {
      action: I18n.t(mode === "Edit" ? "edit" : "create")
    }, undefined),
    disabledIds: disabledShopIds,
    renderItem: renderShopSelectionItem
  });
}

let make = React.memo(CatalogVariantEditContainer);

let Config;

let ProductsQuery;

let VariantQuery;

let ProductQuery;

export {
  Config,
  ProductsQuery,
  VariantQuery,
  ProductQuery,
  make,
}
/* make Not a pure module */
